<div class="selectable-tile-group" [class.selectable-tile-group--compact]="density === 'compact'" role="group" [attr.aria-label]="ariaLabel">
  <button
    type="button"
    class="selectable-tile informational-option"
    *ngFor="let option of optionViews; trackBy: trackByValue"
    [class.is-selected]="option.selected"
    [disabled]="disabled || option.disabled"
    [style.--tile-accent]="option.accentColor"
    [attr.aria-pressed]="option.selected"
    (click)="toggleOption(option)">
    <span class="tile-icon-shell" *ngIf="option.icon" aria-hidden="true">
      <ion-icon [name]="option.icon"></ion-icon>
    </span>
    <span class="tile-label">{{ option.label | translate }}</span>
    <span class="tile-check" *ngIf="option.selected" aria-hidden="true">
      <ion-icon name="checkmark-outline"></ion-icon>
    </span>
  </button>
</div>